import { StyleSheet } from "react-native";


export const InventoryStyle = StyleSheet.create({
    flex: {
        flexDirection: "row",
        alignItems: "center"
    },
    sortContainer: {
        marginVertical: 10,
        marginHorizontal: 8,
        width: 230
    },
    badgeStyle: {
        position: "absolute",
        left: 15,
        top: -8,
        paddingHorizontal: 7
    }
})